module.exports = __webpack_public_path__ + "img/tj.010d1b12.svg";